import React from 'react'
import OurWork from '../components/homepage/OurWork'
import Navbar from '../components/common/Navbar'

const MediaServicesPage = () => {
  return (
    <div className="media-services-page">
        <Navbar/>
        <OurWork/>
    </div>
  )
}

export default MediaServicesPage